import styled, { keyframes, css } from 'styled-components';
import { TabPanel } from '@chakra-ui/react';
import { Form } from '@unform/web';

interface ComplementosPARAM {
  comp: string;
}

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(300px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
`;

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 11;

  div::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }
  div {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }

  .active {
    opacity: 1;
    visibility: visible;
    right: 0px;
    animation: ${appearFromLeft} 0.5s;

    @media (max-width: 650px) {
      top: 0px;
      animation: ${appearFromTop} 0.5s;
    }
  }
`;

export const Content = styled.div`
  background: #fff;
  position: fixed;
  right: -450px;
  width: 700px;
  height: 100%;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  visibility: hidden;
  opacity: 0;
  border-radius: 3px;
  padding: 0 20px;
  transition: all 0.5s ease-out;

  @media (max-width: 850px) {
    right: 0px;
    // top: 800px;
    width: 100%;
    margin-top: 0px;
  }
`;

export const Header = styled.header`
  padding: 10px;

  h1 {
    font-size: 1.6rem;
    font-weight: 600;
  }
`;

export const TabsView = styled.div`
  display: flex;
  width: 100%;
  height: 90%;
  padding: 0 10px;
  // border: 2px solid blue;

  .tabs {
    width: 100%;

    .tab-list {
      .tab {
        font-weight: 500;
        :focus {
          box-shadow: 0 0 0 0;
          border: 0 0;
        }
      }
    }

    .tab-panels {
      width: 100%;
      height: 93.5%;
      position: relative;
      // border: 2px solid orange;

      .tab-panel {
        width: 100%;
        padding: 0;
      }
    }
  }
`;

export const TabDetalhes = styled(TabPanel)`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  width: 100%;
  height: 100%;
`;

export const FormView = styled(Form)<ComplementosPARAM>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 0;
  margin-bottom: 60px;

  div.input-space {
    margin-top: 30px;
  }
  div.input {
    display: flex;
    flex-direction: column;
    width: 100%;

    p {
      font-size: 1rem;
      font-weight: 600;
      margin: 15px 0 3px;

      span {
        font-size: 0.8rem;
        font-weight: 500;
        color: #455a64;
      }
    }

    span.span-caracter {
      font-size: 0.8rem;
      font-weight: 500;
      color: #455a64;
      text-align: end;
      width: 100%;
      padding: 5px 10px 0 0;
    }

    span.span-p {
      font-size: 0.8rem;
      font-weight: 500;
      color: #455a64;
      margin-bottom: 5px;
    }

    .radio-group {
      margin-left: 10px;

      .radio {
        .radio-label {
          display: flex;
          align-items: center;

          :last-child {
            margin-top: 10px;
          }

          input[type='radio'] {
            margin-right: 10px;
            appearance: none;
            font: inherit;
            color: var(--azul-razio);
            width: 18px;
            height: 18px;
            border: 2px solid var(--gray-border-lw);
            border-radius: 50%;

            :checked {
              border: 5px solid var(--azul-razio);
            }
          }

          label {
            font-size: 17px;
          }
        }
      }
    }

    div.pesquisa-produto {
      display: flex;
      flex-direction: column;
      position: absolute;
      top: calc(100% - 525px);
      background-color: #fff;
      border: 1px solid var(--gray-border-lg);
      box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
      border-top: none;
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
      width: 100%;
      height: auto;
      max-height: 250px;
      overflow-y: scroll;
      z-index: 10000;

      ${props =>
        props.comp === 'S'
          ? css`
              width: 49.2%;
            `
          : css`
              width: 100%;
            `}

      div.pesquisa-item {
        cursor: pointer;

        &:hover {
          filter: brightness(0.9);
          background-color: #eceff1;
        }

        span {
          padding: 10px;
          ${props =>
            props.comp === 'S' &&
            css`
              font-size: 0.9rem;
            `}
        }
      }
    }
    div.nome {
      // top: 158px;
      top: calc(100% - 447px);
    }
  }
  div.content-qtds {
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    div.qtds {
      display: flex;

      div.input-qtd {
        display: flex;
        flex-direction: column;
        margin-top: 10px;

        :first-child {
          margin-right: 20px;
        }

        span {
          font-weight: 500;
          padding-bottom: 5px;
        }

        .qtd {
          display: flex;
          padding: 2px;
          border: 1px solid #cfd8dc;
          border-radius: 5px;
          margin-right: 5px;

          button {
            display: flex;
            align-items: center;
            border: none;
            background-color: #fff;
            padding: 5px 10px;
            border-radius: 5px;

            svg {
              font-size: 15px;
              color: #0d47a1;
            }
          }

          span {
            display: flex;
            align-items: center;
            color: #333;
            padding: 5px 10px;
          }
        }
      }
    }
  }
  div.complemento {
    margin-top: 0;

    .input-qtd {
      margin-top: 0 !important;
      margin-left: 10px !important;
    }
  }
  button.button-add {
    font-size: 1.1rem;
    font-weight: 600;
    background-color: var(--azul-razio);
    // border: 2px solid var(--azul-razio);
    color: #fff;
    border-radius: 8px;
    padding: 5px;
    margin-top: 20px;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  right: 0;
  width: 700px;

  button {
    font-weight: 600;
    border-radius: 7px;
    padding: 10px 20px;
    margin: 5px 10px;
  }

  .button-cancel {
    background-color: transparent;
    color: var(--red-razio);
    border: 1px solid var(--red-razio);
  }
  .button-save {
    background-color: var(--azul-razio);
    color: #fff;
    border: 1px solid var(--azul-razio);

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;

export const TabComplementos = styled(TabPanel)<ComplementosPARAM>`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  height: 100%;

  div.panel {
    display: flex;

    ${props =>
      props.comp === 'S'
        ? css`
            flex-direction: row;
          `
        : css`
            flex-direction: column;
          `}
  }
`;

export const Complementos = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px;
  margin-bottom: 60px;
`;

export const Complemento = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #eceff1;
  border: 1px solid #cfd8dc;
  border-radius: 8px;
  padding: 10px;
  margin: 10px 0;
  position: relative;

  div.header {
    display: flex;
    justify-content: space-between;
  }
  div.description {
    h2 {
      font-size: 1rem;
      font-weight: 400;
      color: #607d8b;
    }
  }

  label.remove-complemento {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    border-radius: 50%;
    border: 0;
    cursor: pointer;
    transition: background-color 0.2s;
    width: 30px;
    height: 30px;
    background-color: #eceff1;
    border: 2px solid var(--red-razio);
    right: -10px;
    bottom: -12px;

    svg {
      color: var(--red-razio);
    }
  }
`;
